import React from 'react';
import { useTranslation } from 'react-i18next';

interface IExperienceTagProps {
  active?: boolean;
  style?: React.CSSProperties;
}


export const ExperienceTag = (props: IExperienceTagProps) => {
  const { t } = useTranslation();
  const { active, style } = props;
  return <div style={style}>
  <span style={active ? { background: '#5C9DFF', color: '#fff' } : undefined} className={'ml-[4px] rounded-[2px] px-[2px] py-[2px] text-[#4A5970] bg-[#EDF1F7] text-[10px] experience-tag-active-hover'}>{t('体验')}</span>
</div>;
};
